(() => {
  const hydrateItem = async (item) => {
    if (!item?.handle || item.memoryHydrated === true) return item;

    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return item;

      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant = variants.find((candidate) => candidate.available) || variants[0];
      const images = (Array.isArray(product.images) ? product.images : [])
        .map((image) => (typeof image === 'string' ? image : image?.src))
        .filter(Boolean);

      return {
        ...item,
        productId: product.id || item.productId,
        variantId: variant?.id || item.variantId,
        image: images[0] || item.image,
        images: images.length ? images : (item.images || []),
        available: Boolean(variant?.available),
        memoryHydrated: true,
      };
    } catch (_error) {
      return item;
    }
  };

  window.LetoileRecentProducts = {
    hydrate: (items) => Promise.all(items.map(hydrateItem)),
  };
})();
